import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import type { AppMenu } from '@modules/sidebar/utils';
import { AppModule } from '@modules/core/plugins/AppModule';
import { useI18n } from '@modules/i18n/composables';
import {
  ADMIN_SETTINGS_MENU_ITEM,
  TRANSLATION_GROUP_SIDEBAR,
} from '@modules/sidebar/constants';

import {
  ADMIN_TRANSLATION_MANAGER_ROUTE_NAME,
  TRANSLATE_MANAGER_PERMISSIONS,
  TRANSLATION_GROUP_TRANSLATE_MANAGER,
} from './constants';
import { getTranslationKeys } from './translations';

export class TranslateManagerModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    router.addAdminRoute({
      name: ADMIN_TRANSLATION_MANAGER_ROUTE_NAME,
      path: 'translate-manager',
      component: () => import('./pages/TranslateManagerPage/TranslateManagerPage.vue'),
      permission: TRANSLATE_MANAGER_PERMISSIONS.TRANSLATEMANAGER_EDIT,
    });
  }

  addMenu(menu: AppMenu): void {
    const { getTPath } = useI18n();

    menu.addChildAdminMenuItem(ADMIN_SETTINGS_MENU_ITEM, {
      caption: getTPath(TRANSLATION_GROUP_SIDEBAR, 'SYSTEM_SETTINGS_TRANSLATE_MANAGER'),
      to: {
        name: ADMIN_TRANSLATION_MANAGER_ROUTE_NAME,
      },
      permission: TRANSLATE_MANAGER_PERMISSIONS.TRANSLATEMANAGER_EDIT,
      id: ADMIN_TRANSLATION_MANAGER_ROUTE_NAME,
      order: 20,
    });
  }

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_TRANSLATE_MANAGER, getTranslationKeys);
  }
}
